import type {
  BesoinAchat,
  CommandeFournisseurCreatePayload,
} from "@/types/domain";

export function fournisseursCommuns(
  besoins: BesoinAchat[],
): BesoinAchat["fournisseurs_compatibles"] {
  if (besoins.length === 0) return [];

  const autres = besoins.slice(1).map(
    (besoin) => new Set(besoin.fournisseurs_compatibles.map((f) => f.id)),
  );
  return besoins[0].fournisseurs_compatibles.filter((fournisseur) =>
    autres.every((ids) => ids.has(fournisseur.id)),
  );
}

export function construireCommandeFournisseur(
  besoins: BesoinAchat[],
  fournisseurId: string,
  numero: string,
): CommandeFournisseurCreatePayload {
  const numeroNormalise = numero.trim();
  if (!besoins.length) throw new Error("Sélectionnez au moins un besoin.");
  if (!numeroNormalise) throw new Error("Le numéro de commande est requis.");
  if (!fournisseursCommuns(besoins).some((f) => f.id === fournisseurId)) {
    throw new Error("Le fournisseur n’est pas compatible avec tous les besoins.");
  }

  return {
    fournisseur_id: fournisseurId,
    numero_commande_fournisseur: numeroNormalise,
    lignes: besoins.map((besoin) => ({
      besoin_achat_id: besoin.id,
      quantite_commandee: besoin.quantite_a_acheter,
    })),
  };
}
